import React from 'react';
import { OrderListBreadcrumbs } from './OrderProcessing/OrderListBreadcrumbs';
import { ButcherHeader } from './ButcherHeader';
import { SideNav } from './OrderCreation/OrderSideNav';
import {
  OrderProcessingMasterData,
  SettignsCrumbSteps,
  SpeciesAndProductSetupCrumbSteps,
} from '@helpers/Constants';
// import { Assets } from '@helpers/Constants/Assets';

export const OnBoardSettings: React.FC<{
  renderContent: React.ReactNode;
  speciesSetup?: boolean;
}> = ({ renderContent, speciesSetup }) => {
  const BreadCrumbsProps = {
    steps: SettignsCrumbSteps,
    activeItem: 'My Store Settings',
    type: OrderProcessingMasterData.MY_STORE_SETTINGS,
  };

  const SpeciesAndProductSetup = {
    steps: SpeciesAndProductSetupCrumbSteps,
    activeItem: 'Species & Product Set Up',
    type: OrderProcessingMasterData.SPECIES_AND_PRODUCT_SETUP,
  };

  return (
    <>
      <div className="flex h-screen w-screen gap-1">
        {/* Sidebar */}
        {/* Species and ProductSetup - id - 9 and My store settings - id - 8 */}
        <SideNav active={speciesSetup ? 9 : 8} />
        {/* Main Content */}
        <div className="flex-1 overflow-auto relative">
          {/* Header */}
          <ButcherHeader />
          <OrderListBreadcrumbs
            orderInfo={speciesSetup ? SpeciesAndProductSetup : BreadCrumbsProps}
          />
          <div>
            <div className="flex items-center justify-between whitespace-nowrap">
              <h1 className="font-semibold text-xl px-4 mt-3 mb-3">
                {speciesSetup
                  ? 'Species & Product Set Up'
                  : 'My Store Settings'}
              </h1>
              {/* App settings */}
              {/* <button
                type="button"
                className="text-primary p-2 font-bold flex justify-between"
              >
                <img
                  src={Assets.APP_SETTINGS}
                  className="w-6 h-6 mr-1"
                  alt="AppSettings"
                />
                <span>App Settings</span>
              </button> */}
            </div>
            <>{renderContent}</>
          </div>
        </div>
      </div>
    </>
  );
};
